export default __webpack_public_path__ + "static/logo-mycrypto-3471da0a5adbfebea30a9cf954446971.svg";